import React, { useCallback } from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { Checkbox } from 'antd';
import OrderListItem from './OrderListItem';
import './VirtualizedOrderList.css';

const VirtualizedOrderList = ({
  orders,
  columnStyle,
  onOrderClick,
  formatDate,
  getStatusColor,
  getStatusLabel,
  onSelect,
  selectedOrderIds,
  onOrdersUpdate,
  isStaff
}) => {
  const Row = useCallback(({ index, style }) => {
    const item = orders[index];
    if (!item) return null;

    return (
      <div style={{ ...style, padding: '0', fontSize: '1.1em' }} className="order-list-item">
        <div 
          className={`order ${selectedOrderIds.includes(item.id) ? 'selected' : ''}`}
          style={{
            ...columnStyle.orderContainer, 
            margin: 0,
            backgroundColor: item.status === 'INSPECTION_NEEDED' || item.status === '查验件' ? '#f5d0cd' : 
                           item.status === 'DUPLICATE' || item.status === '重复订单' ? '#ffd7ae' : 'transparent'
          }}
        >
          <div style={columnStyle.checkbox}>
            <Checkbox 
              checked={selectedOrderIds.includes(item.id)} 
              onChange={(e) => onSelect && onSelect(item.id, e.target.checked)}
              style={{ marginLeft: '-4px' }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div 
            style={{ ...columnStyle.container, flex: 1, cursor: 'pointer' }} 
            onClick={(e) => {
              e.stopPropagation();
              onOrderClick(item);
            }}
          >
            <OrderListItem
              item={{...item, index}}
              columnStyle={columnStyle}
              onOrderClick={onOrderClick}
              formatDate={formatDate}
              getStatusColor={getStatusColor}
              getStatusLabel={getStatusLabel}
              onSelect={onSelect}
              isSelected={selectedOrderIds.includes(item.id)}
              onOrdersUpdate={onOrdersUpdate}
              isStaff={isStaff}
            />
          </div>
        </div>
      </div>
    );
  }, [orders, columnStyle, onOrderClick, formatDate, getStatusColor, getStatusLabel, onSelect, selectedOrderIds, onOrdersUpdate, isStaff]);

  return (
    <div style={{ flex: 1, width: '100%', height: '100%' }}>
      <AutoSizer>
        {({ height, width }) => (
          <List
            height={height}
            width={width}
            itemCount={orders.length}
            itemSize={32} // Further reduced row height to match original
            overscanCount={10} // Number of items to render outside of the visible area
            className="virtualized-order-list"
          >
            {Row}
          </List>
        )}
      </AutoSizer>
    </div>
  );
};

export default React.memo(VirtualizedOrderList);
